import React from 'react';
import { SysMenuTile } from './tile';
import { T } from '../../../../components/basic/text';
import { Dashboard } from '../../types';

export const SysMenuTiles = ({ menus }: { menus: Dashboard.TileGroupDTO[] }) => {
    return (
        <div className="sys-menu flex-grow-1">
            {menus.map((g, gIndex) => {
                const tiles = g.items;

                return (
                    <div key={g.title} className="sys-menu-group">
                        {gIndex >= 0 && (
                            <T as="h5" className="text-muted">
                                {g.title}
                            </T>
                        )}
                        {tiles.length > 0 && (
                            <div className="tiles">
                                {tiles.map(m => (
                                    <React.Fragment key={m.id + m.title}>
                                        <SysMenuTile tile={m} />
                                    </React.Fragment>
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
